import { getWarningModalTranslatedKey } from '../../../constants/text/utils';

const useConstLang = () => {
  const title = getWarningModalTranslatedKey('title');
  const cancelEditingButton = getWarningModalTranslatedKey('cancelEditingButton');
  const closeButton = getWarningModalTranslatedKey('closeButton');

  return {
    title,
    cancelEditingButton,
    closeButton
  };
};

export default useConstLang;